import { createSlice } from '@reduxjs/toolkit'

export const leadLevelsSlice = createSlice({
    name: 'leadLevels',
    initialState: {
        leadLevels: []
    },
    reducers: {
        setLeadLevels(state, action) {
            state.leadLevels = action.payload.slice().sort((a, b) => 
                a.name.localeCompare(b.name)
            );
        },
    },
})

export const { setLeadLevels } = leadLevelsSlice.actions;

export default leadLevelsSlice.reducer

